import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { styled } from '@mui/material';

export const LabelValueContainer = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'hideButtonBorder',
})<{ hideButtonBorder: boolean }>(({ theme, hideButtonBorder }) => ({
  gap: theme.spacing(8),
  wordBreak: 'break-all',
  alignItems: 'center',
  paddingBottom: hideButtonBorder ? 0 : theme.spacing(6),
  ...(!hideButtonBorder && {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  }),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
  },
}));

export const LabelText = styled(Text)(({ theme }) => ({
  wordBreak: 'break-word',
  minWidth: 200,
  maxWidth: 200,
  flex: 1,
  color: theme.palette.grey.A100,
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    width: '100%',
  },
}));
